<template>
  <div class="pie-chart-container">
      <div  ref="pieChart" class="chart" id="dv"></div>
    <div class="ok-text" v-if="resultList.length<=0">暂无问题，请继续保持。</div>
  </div>
</template>

<script>
import { Pie } from "@antv/g2plot";
import { Mix } from "@antv/g2plot";
import { left } from "@antv/g2plot/lib/plots/sankey/sankey";

export default {
  name: "pieChart",
  props: {
    /**
     * 数据
     * @type {
     *     Array<{ name:string; value: number }>
     * }
     */
    resultList: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    resultList: function (newVal, oldVal) {
      if (this.piePlot) {
        this.piePlot.destroy();
      }
      this.initChart();
    },
  },
  mounted() {},
  data() {
    return {
      piePlot: null,
    };
  },
  methods: {
    /**
     * 初始图
     */
    // initChart() {
    //   this.piePlot = new Pie(this.$refs.pieChart, {
    //     color: ["#5B8FF9", "#444693", "#6EB672", "#F7C739", "#E8684A", "#FF8B5B", "#5AD8A6", "#faa755", "#EB7E65", "#73A0FA"],
    //     appendPadding: [5, 0, 14, 0],
    //     data: this.resultList,
    //     angleField: "value",
    //     colorField: "name",
    //     innerRadius: 0.6,
    //     legend: false,
    //     // legend: {
    //     //   layout: "horizontal",
    //     //   position: "bottom",
    //     //   flipPage: false,
    //     //   itemWidth: 100,
    //     //   offsetY: -2,
    //     //   itemName: {
    //     //     style: {
    //     //       fill: "#8C8C8C",
    //     //       fontSize: 10,
    //     //     },
    //     //   },
    //     // },
    //     label: {
    //       type: "spider",
    //       labelHeight: 18,
    //       content: "({value}){name}",
    //       layout: {
    //         //   type:'limit-in-shape'
    //       },
    //       style: {
    //         fontSize: 10,
    //       },
    //     },
    //     animation: false,
    //     statistic: {
    //       title: false,
    //       content: true,
    //     },
    //   });
    //   this.piePlot.render();
    //   this.piePlot.on("element:click", (evt) => {
    //     let typeData = evt.data.data;
    //     this.$emit("circeClick", typeData);
    //   });
    // },
    // 多面图
    initChart() {
      // console.log("制作");
      this.piePlot = new Mix(this.$refs.pieChart, {
        tooltip: { shared: true, showLabel: true },
        syncViewPadding: true,
        padding: [5, 20, 14, 20],
        plots: [
          {
            type: "pie",
            options: {
              data: this.resultList,
              color: [
                "#5B8FF9",
                "#444693",
                "#6EB672",
                "#F7C739",
                "#E8684A",
                "#FF8B5B",
                "#5AD8A6",
                "#faa755",
                "#EB7E65",
                "#73A0FA",
              ],
              padding: [5, 20, 14, 20],
              innerRadius: 0.6,
              angleField: "value",
              colorField: "name",
              legend: false,
              label: {
                type: "spider",
                labelHeight: 30,
                content: function (e) {
                    let name = e.name
                  if (e.name.length >5) {
                    name = e.name.slice(0,5)+'\n'+e.name.slice(5)
                  }
                  return name;
                },
                style: {
                  fontSize: 10,
                  textAlign: "center",
                },
                layout: "limitInShape",
              },
              animation: false,
              statistic: {
                title: false,
                content: true,
              },
            },
          },
          {
            type: "pie",
            options: {
              data: this.resultList,
              color: [
                "#5B8FF9",
                "#444693",
                "#6EB672",
                "#F7C739",
                "#E8684A",
                "#FF8B5B",
                "#5AD8A6",
                "#faa755",
                "#EB7E65",
                "#73A0FA",
              ],
              innerRadius: 0.6,
              angleField: "value",
              colorField: "name",
              legend: false,
              label: {
                autoRotate:false,
                type: "inner",
                content: "{value}",
                style: {
                  fontSize: 10,
                },
              },
              animation: false,
              statistic: {
                title: false,
                content: true,
              },
            },
          },
        ],
      });
      this.piePlot.render();
      this.piePlot.on("element:click", (evt) => {
        let typeData = evt.data.data;
        this.$emit("circeClick", typeData);
      });
    },
  },
};
</script>

<style scoped lang="scss">
.pie-chart-container {
  //border: 1px solid yellowgreen;
  //   width: 95%;
  position: relative;
  //   margin: 0 auto;

  .chart {
    // height: 592px;
    height: 500px;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .ok-text{
    position: absolute;
    white-space: nowrap;
    text-align: center;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    color: #A2A2A2;
    font-size: 30px;
  }
}
</style>
